import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { Moneda } from '../../shared/moneda/monedas';

export const monedaService = {
  getAll: (): Promise<ApiResponse<Moneda[]>> => {
    return httpClient.get('/monedas');
  },
};
